import Pagination from "../components/Pagination";
import ShuffleGrid from "../components/Shuffle";
import reset from "../utils/reset_events.js";

const formHelpers = {
    status: function (form, form_data) {
        // Display selected filters status
        if (form.hasAttribute("data-display-status")) {
            let status_element = document.querySelector("[data-form-status]");
            let message = status_element.querySelector("[data-status-message]");
            message.innerHTML = "";

            let status = [];
            for (const pair of form_data.entries()) {
                if (pair[1]) {
                    let label = document.querySelector(`[value="${pair[1]}"`);
                    status.push([
                        `<span class="filter-status">${pair[0]}: ${label.textContent}</span>`,
                    ]);
                }
                // console.log("here", status, pair);
            }
            if (status.length) {
                status = `Currently filtered by ${status.join(" and ")}`;
                message.innerHTML = status;
                status_element.classList.add("active");
            }
        }
    },
    simple: {
        items: document.querySelectorAll(".card"),
        formSubmit: (e) => {
            e.preventDefault();

            let form = e.currentTarget;
            let form_data = new FormData(form);
            let filtered;

            const feed = document.querySelector(".feed-list");
            const items = formHelpers.simple.items;

            // Build query string
            let query = new Set();
            for (const pair of form_data.entries()) {
                if (pair[1]) query.add(pair[1]);
            }

            if (query.size > 0) {
                filtered = [...items].filter((item) => {
                    let classes = item.classList.values();
                    classes = new Set(classes);

                    let intersection = new Set(
                        [...classes].filter((x) => query.has(x)),
                    );
                    intersection = intersection.size ? true : false;
                    return intersection;

                    // return !classes.isDisjointFrom(query);
                });
            } else {
                filtered = items;
            }

            feed.innerHTML = "";
            filtered.forEach((item) => {
                feed.append(item);
            });

            let reset = form.querySelector('[type="reset"]');
            if (reset) {
                reset.classList.add("active");
            }

            // console.log("Classes:", filtered, query.size, formHelpers);
        },
    },

    ajax: {
        formSubmit: async (e) => {
            e.preventDefault();

            let form = e.currentTarget;

            const parser = new DOMParser();
            const target = document.querySelector(form.dataset.target);
            const listing = target.querySelector('[role="list"]');
            let pagination = target.querySelector(".pagination");

            // Collect form data
            let form_data = new FormData(form);

            // Build query string
            let query = [];
            for (const pair of form_data.entries()) {
                query.push([`${pair[0]}=${pair[1]}`]);
            }

            // Updates browser history
            if (query.length) {
                query = query.join("&");
                window.history.replaceState(null, null, `?${query}`);
            } else {
                window.history.replaceState(null, null, form.action);
            }

            // Request filtered content
            const payload = {
                method: "POST",
                credentials: "include",
                headers: new Headers({
                    "Content-Type": "application/x-www-form-urlencoded",
                }),
                body: query.concat([`&ajax=1`]),
            };
            const response = await fetch(form.action, payload);
            let data = await response.text();

            // Parse the response into HTML
            var doc = parser.parseFromString(data, "text/html");
            let list = doc.querySelector('[role="list"]');

            formHelpers.status(form, form_data);

            // Replace listing content
            listing.innerHTML = list.innerHTML;

            // Masonry
            if (listing.hasAttribute("data-shuffle")) {
                new ShuffleGrid(listing);
            }

            if (typeof window.instgrm !== "undefined") {
                window.instgrm.Embeds.process();
            }

            // Pagination - Append or remove based on filters results
            let list_pagination = doc.querySelector(".pagination");
            if (list_pagination) {
                if (!pagination) {
                    target.appendChild(list_pagination);
                } else {
                    pagination.innerHTML = list_pagination.innerHTML;
                    pagination.style.display = "block";
                }

                pagination = target.querySelector(".pagination");
                new Pagination(pagination);
            } else {
                pagination?.remove();
                pagination = null;
            }

            reset.refreshDialogs(target);

            let scroll_to = document.querySelector("#site-header").offsetHeight;
            window.scrollTo({
                top: scroll_to,
                left: 0,
                behavior: "smooth",
            });
        },
    },
};

export default formHelpers;
